import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editAuditDialog from '../../dialog.editAuditDialog';
import controller from './completed-audit.controller';
import directive from './completed-audit.directive';
import findingCategories from '../findingCategories';
import preparationItemCategories from '../preparationItemCategories';


export default angular.module('app.components.advisory.auditTrail.completedAudit', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  editAuditDialog,
  findingCategories,
  loaderService,
  orgDataService,
  preparationItemCategories,
  ssDialogService,
  userService,
])
  .directive('amCompletedAudit', directive)
  .controller('CompletedAuditController', controller)
  .name;

console.log('app.components.advisory.auditTrail.completedAudit created');
